import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";
import ProtectAdminRoute from "../components/ProtectRoute";

// Admin Layout
const AdminLayout = Loadable(lazy(() => import("../layouts/AdminLayout")));
// Admin Dashboard
const AdminDashboard = Loadable(lazy(() => import("../views/Admin/dashboard")));
// Admin Profile
const PersonalDetails = Loadable(lazy(() => import("../views/Admin/UserManagement/personalDetails")));
// Admin Change Password
const ChangesPassword = Loadable(lazy(() => import("../views/Admin/UserManagement/changesPassword")));
// User Management
const UserManagementList = Loadable(lazy(() => import("../views/Admin/UserManagement/userManagement")));
const AddNewUserAdmin = Loadable(lazy(() => import("../views/Admin/UserManagement/addNewUser")));
const UpdateUserProfileAdmin = Loadable(lazy(() => import("../views/Admin/UserManagement/userProfiles/userProfileMenu")));
const AppUsersSettings = Loadable(lazy(() => import("../views/Admin/UserManagement/appUsersSettings")));
const UserServiceStatus = Loadable(lazy(() => import("../views/Admin/UserManagement/userServiceStatus")));
const PendingKycVerificationList = Loadable(lazy(() => import("../views/Admin/UserManagement/pendingKycVerification")));
const UserRequestList = Loadable(lazy(() => import("../views/Admin/UserManagement/userRequestList")));
const BlockedIPAddressUsers = Loadable(lazy(() => import("../views/Admin/UserManagement/blockedIPAddressUsers")));
const UpdateOnboardingExcelSheet = Loadable(lazy(() => import("../views/Admin/UserManagement/updateOnboardingExcelSheet")));
// Balance Request
const BalanceRequestLists = Loadable(lazy(() => import("../views/Admin/BalanceRequest/balanceRequestLists")));
const ViewPendingRequestAdmin = Loadable(lazy(() => import("../views/Admin/BalanceRequest/viewPendingRequestAdmin")));
const CreditDebitUsers = Loadable(lazy(() => import("../views/Admin/BalanceRequest/creditDebitUsers")));
// Commission
const AllPlanList = Loadable(lazy(() => import("../views/Admin/Commission/allPlanList")));
const CommissionPlanMaster = Loadable(lazy(() => import("../views/Admin/Commission/createCommissionPlanMaster")));
const GetCommissionPlanMaster = Loadable(lazy(() => import("../views/Admin/Commission/getCommissionPlanMaster")));
const GetAPICommissionMaster = Loadable(lazy(() => import("../views/Admin/Commission/getAPICommissionMaster")));
const GetAPTServiceMasterCommission = Loadable(lazy(() => import("../views/Admin/Commission/getAPTServiceMasterCommission")));
const APIServiceMasterCommissionReport = Loadable(lazy(() => import("../views/Admin/Commission/apiServiceMasterCommissionReport")));
// Manage Bank
const AdminSelfBank = Loadable(lazy(() => import("../views/Admin/ManageBank/adminSelfBank")));
const BankDataManager = Loadable(lazy(() => import("../views/Admin/ManageBank/bankDataManager")));
const PaymentOperatorList = Loadable(lazy(() => import("../views/Admin/ManageBank/paymentOperatorList")));
// API Config
const AppConfig = Loadable(lazy(() => import("../views/Admin/ApiConfig/appConfig")));
const APILogs = Loadable(lazy(() => import("../views/Admin/ApiConfig/apiLogs")));
const WebHook = Loadable(lazy(() => import("../views/Admin/ApiConfig/webHook")));
const SMSLogs = Loadable(lazy(() => import("../views/Admin/ApiConfig/smsLogs")));
const SetCharges = Loadable(lazy(() => import("../views/Admin/ApiConfig/setCharges")));
const APIForwardSwitch = Loadable(lazy(() => import("../views/Admin/ApiConfig/apiForwardSwitch")));
const AdminAPIRequestReponseStatus = Loadable(lazy(() => import("../views/Admin/ApiConfig/adminAPIRequestReponseStatus")));
const APISwitch = Loadable(lazy(() => import("../views/Admin/ApiConfig/apiSwitch")));
// Managment
const SystemSetting = Loadable(lazy(() => import("../views/Admin/Management/systemSetting")));
const UserServicesControl = Loadable(lazy(() => import("../views/Admin/Management/userServicesControl")));
const ServicesControl = Loadable(lazy(() => import("../views/Admin/Management/servicesControl")));
const LoginHistory = Loadable(lazy(() => import("../views/Admin/Management/loginHistory")));
// const ComplaintManager = Loadable(lazy(() => import("../views/Admin/Management/complaintManager")));
const CustomerLimitInc = Loadable(lazy(() => import("../views/Admin/Management/customerLimitInc")));
const CustomerNameUpdate = Loadable(lazy(() => import("../views/Admin/Management/customerNameUpdate")));
const ChangeTpin = Loadable(lazy(() => import("../views/Admin/Management/changeTpin")));
const NotificationList = Loadable(lazy(() => import("../views/Admin/Management/notificationList")));
// Compaint Mangment
const ComplaintInternalManager = Loadable(lazy(() => import("../views/complaint/complaintList")));
const ComplaintInternalAdd = Loadable(lazy(() => import("../views/complaint/complaintAdd")));
const ComplaintInternalDetails = Loadable(lazy(() => import("../views/complaint/complaintDetails")));
// Reports
const GetLiveTransaction = Loadable(lazy(() => import("../views/Admin/Reports/getLiveTransaction")));
const UserLedgerReport = Loadable(lazy(() => import("../views/Admin/Reports/userLedgerReport")));
const AdminSelfLedger = Loadable(lazy(() => import("../views/Admin/Reports/adminSelfLedger")));
const PayoutTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/payoutTransactionReports")));
const CommissionTransectionReports = Loadable(lazy(() => import("../views/Admin/Reports/commissionTransectionReports")));
const WalletToWalletReports = Loadable(lazy(() => import("../views/Admin/Reports/walletToWalletReports")));
const GSTTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/gstTransactionReports")));
const TDSTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/tdsTransactionReports")));
const DMTTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/dmtTransactionReports")));
const PaymentGetwayReports = Loadable(lazy(() => import("../views/Admin/Reports/paymentGetwayReports")));
const PGTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/pgTransactionReports")));
const PendingTransectionReport = Loadable(lazy(() => import("../views/Admin/Reports/pendingTransectionReport")));
const OfflineTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/offlineTransactionReports")));
const DailyTrasactionReports = Loadable(lazy(() => import("../views/Admin/Reports/dailyTrasactionReports")));
const BillPaymentReports = Loadable(lazy(() => import("../views/Admin/Reports/billPaymentReports")));
const RailTicketBooking = Loadable(lazy(() => import("../views/Admin/Reports/railTicketBooking")));
const FlightTicketBooking = Loadable(lazy(() => import("../views/Admin/Reports/flightTicketBooking")));
const AEPSTransactionReports = Loadable(lazy(() => import("../views/Admin/Reports/aepsTransactionReports")));
const CashoutTransaction = Loadable(lazy(() => import("../views/Admin/Reports/cashoutTransaction")));
const RefundReport = Loadable(lazy(() => import("../views/Admin/Reports/refundReport")));
const CashoutDirectReport = Loadable(lazy(() => import("../views/Admin/Reports/cashoutDirectReport")));
const BusinessReport = Loadable(lazy(() => import("../views/Admin/Reports/businessReport")));
const BusinessAnalysisReport = Loadable(lazy(() => import("../views/Admin/Reports/businessAnalysisReport")));
const DailyBusinessReports = Loadable(lazy(() => import("../views/Admin/Reports/dailyBusinessReports")));
const TopUpReport = Loadable(lazy(() => import("../views/Admin/Reports/topUpReport")));
const AccountStatusReports = Loadable(lazy(() => import("../views/Admin/Reports/accountStatusReports")));
const Users360Report = Loadable(lazy(() => import("../views/Admin/Reports/users360Report")));
const ChangeStatusByTxnId = Loadable(lazy(() => import("../views/Admin/Reports/changeStatusByTxnId")));

// HelpDesk
const ComplaintList = Loadable(lazy(() => import("../views/HelpDesk/ComplaintList")));
const NewComplaint = Loadable(lazy(() => import("../views/HelpDesk/NewComplaint")));
const ComplaintDetails = Loadable(lazy(() => import("../views/HelpDesk/ComplaintDetails")));

const adminRouter = {
  path: "/:accessType",
  key: 2,
  element: <ProtectAdminRoute Component={AdminLayout} />,
  children: [
    {
      key: 2.1,
      path: "dashboard",
      name: "adminDashboard",
      element: <AdminDashboard />,
    },
    // User Managemnet
    {
      path: "userManagement",
      key: 2.2,
      children: [
        {
          path: "appUsersSettings",
          name: "userManagement-appUsersSettings",
          element: <AppUsersSettings />,
        },
        {
          path: "userServiceStatus",
          name: "userManagement-userServiceStatus",
          element: <UserServiceStatus />,
        },
        {
          path: "pendingKycVerification",
          name: "userManagement-pendingKycVerification",
          element: <PendingKycVerificationList />,
        },
        {
          path: "userRequest",
          name: "userManagement-userRequest",
          element: <UserRequestList />,
        },
        {
          path: "unblockIPAddressUser",
          name: "userManagement-unblockIPAddressUser",
          element: <BlockedIPAddressUsers />,
        },
        {
          path: "updateOnboardingExcelSheet",
          name: "userManagement-updateOnboardingExcelSheet",
          element: <UpdateOnboardingExcelSheet />,
        },
        // for all role type user list
        {
          path: ":userType",
          name: "userManagement-allUserTypeList",
          element: <UserManagementList />,
        },
        // for all role type new user
        {
          path: "newUser/:userType",
          name: "userManagement-newUser",
          element: <AddNewUserAdmin />,
        },
        // for all role type user profile
        {
          path: "profile/:userType",
          name: "userManagement-userProfile",
          element: <UpdateUserProfileAdmin />,
        },
      ],
    },
    // Balance Request
    {
      path: "balanceRequest",
      key: 2.3,
      children: [
        {
          path: "",
          name: "balanceRequest-viewBalanceRequestAdmin",
          element: <BalanceRequestLists />,
        },
        {
          path: "viewPendingRequest",
          name: "balanceRequest-viewPendingRequest",
          element: <ViewPendingRequestAdmin />,
        },
        {
          path: "creditDebitUsers",
          name: "balanceRequest-creditDebitUsers",
          element: <CreditDebitUsers />,
        },
      ]
    },
    // Commission
    {
      path: "commission",
      key: 2.4,
      children: [
        {
          path: "allPlans",
          name: "commission-allPlans",
          element: <AllPlanList />,
        },
        {
          path: "commissionPlanMaster",
          name: "commission-commissionPlanMaster",
          element: <CommissionPlanMaster />,
        },
        {
          path: "getCommissionMasterTemp",
          name: "commission-getCommissionMasterTemp",
          element: <GetCommissionPlanMaster />,
        },
        {
          path: "getAPICommissionMaster",
          name: "commission-getAPICommissionMaster",
          element: <GetAPICommissionMaster />,
        },
        {
          path: "getAPIServiceCommissionMasterTemp",
          name: "commission-getAPIServiceCommissionMasterTemp",
          element: <GetAPTServiceMasterCommission />,
        },
        {
          path: "apiServiceMasterCommissionReport",
          name: "commission-apiServiceMasterCommissionReport",
          element: <APIServiceMasterCommissionReport />,
        },
      ]
    },
    // Manage Bank
    {
      path: "mangeBank",
      key: 2.5,
      children: [
        {
          path: "adminSelfBank",
          name: "mangeBank-adminSelfBank",
          element: <AdminSelfBank />,
        },
        {
          path: "bankDataManager",
          name: "mangeBank-bankDataManager",
          element: <BankDataManager />,
        },
        {
          path: "paymentOperatorList",
          name: "mangeBank-paymentOperatorList",
          element: <PaymentOperatorList />,
        },
      ]
    },
    // API Config
    {
      path: "apiConfig",
      key: 2.6,
      children: [
        {
          path: "appConfig",
          name: "appConfig-systemSetting",
          element: <AppConfig />,
        },
        {
          path: "apiLogs",
          name: "appConfig-apiLogs",
          element: <APILogs />,
        },
        {
          path: "webHook",
          name: "appConfig-webHook",
          element: <WebHook />,
        },
        {
          path: "smsLogs",
          name: "appConfig-smsLogs",
          element: <SMSLogs />,
        },
        {
          path: "setCharges",
          name: "appConfig-setCharges",
          element: <SetCharges />,
        },
        {
          path: "apiForwardSwitch",
          name: "appConfig-apiForwardSwitch",
          element: <APIForwardSwitch />,
        },
        {
          path: "apiRequestResponseAdmin",
          name: "appConfig-apiRequestResponseAdmin",
          element: <AdminAPIRequestReponseStatus />,
        },
        {
          path: "apiSwitch",
          name: "appConfig-apiSwitch",
          element: <APISwitch />,
        },
      ]
    },
    // Managemnet
    {
      path: "management",
      key: 2.7,
      children: [
        {
          path: "systemSetting",
          name: "management-systemSetting",
          element: <SystemSetting />,
        },
        {
          path: "userServicesControl",
          name: "management-userServicesControl",
          element: <UserServicesControl />,
        },
        {
          path: "servicesControl",
          name: "management-servicesControl",
          element: <ServicesControl />,
        },
        {
          path: "loginHistory",
          name: "management-loginHistory",
          element: <LoginHistory />,
        },
        {
          path: "complaintManager",
          name: "management-complaintInternalManager",
          element: <ComplaintInternalManager />,
        },
        {
          path: "addComplaint",
          name: "management-complaintInternalAdd",
          element: <ComplaintInternalAdd />,
        },
        {
          path: "complaintDetails",
          name: "management-complaintInternalDetails",
          element: <ComplaintInternalDetails />,
        },
        {
          path: "customerLimitInc",
          name: "management-customerLimitInc",
          element: <CustomerLimitInc />,
        },
        {
          path: "customerNameUpdate",
          name: "management-customerNameUpdate",
          element: <CustomerNameUpdate />,
        },
        {
          path: "changeTpin",
          name: "management-changeTpin",
          element: <ChangeTpin />,
        },
        {
          path: "notification",
          name: "management-notification",
          element: <NotificationList />,
        },
      ]
    },
    // Reports
    {
      path: "reports",
      key: 2.8,
      children: [
        {
          path: "getLiveTransaction",
          name: "reports-getLiveTransaction",
          element: <GetLiveTransaction />,
        },
        {
          path: "userLedgerReports",
          name: "reports-userLedgerReports",
          element: <UserLedgerReport />,
        },
        {
          path: "adminSelfLedger",
          name: "reports-adminSelfLedger",
          element: <AdminSelfLedger />,
        },
        {
          path: "payoutTransactionReports",
          name: "reports-payoutTransactionReports",
          element: <PayoutTransactionReports />,
        },
        {
          path: "commissionTransectionReports",
          name: "reports-commissionTransectionReports",
          element: <CommissionTransectionReports />,
        },
        {
          path: "walletToWalletReport",
          name: "reports-walletToWalletReport",
          element: <WalletToWalletReports />,
        },
        {
          path: "gstTransactionReports",
          name: "reports-gstTransactionReports",
          element: <GSTTransactionReports />,
        },
        {
          path: "tdsTransactionReports",
          name: "reports-tdsTransactionReports",
          element: <TDSTransactionReports />,
        },
        {
          path: "dmtTransactionReports",
          name: "reports-dmtTransactionReports",
          element: <DMTTransactionReports />,
        },
        {
          path: "paymentGetwayReports",
          name: "reports-paymentGetwayReports",
          element: <PaymentGetwayReports />,
        },
        {
          path: "pgTransactionReports",
          name: "reports-pgTransactionReports",
          element: <PGTransactionReports />,
        },
        {
          path: "pendingTransectionReport",
          name: "reports-pendingTransectionReport",
          element: <PendingTransectionReport />,
        },
        {
          path: "offlineTransactionReports",
          name: "reports-offlineTransactionReports",
          element: <OfflineTransactionReports />,
        },
        {
          path: "dailyTrasactionReports",
          name: "reports-dailyTrasactionReports",
          element: <DailyTrasactionReports />,
        },
        {
          path: "billPaymentReports",
          name: "reports-billPaymentReports",
          element: <BillPaymentReports />,
        },
        {
          path: "railTicketBooking",
          name: "reports-railTicketBooking",
          element: <RailTicketBooking />,
        },
        {
          path: "flightTicketBooking",
          name: "reports-flightTicketBooking",
          element: <FlightTicketBooking />,
        },
        {
          path: "aepsTransactionReports",
          name: "reports-aepsTransactionReports",
          element: <AEPSTransactionReports />,
        },
        {
          path: "cashoutTransaction",
          name: "reports-cashoutTransaction",
          element: <CashoutTransaction />,
        },
        {
          path: "refundReport",
          name: "reports-refundReport",
          element: <RefundReport />,
        },
        {
          path: "cashoutDirectAPIReport",
          name: "reports-cashoutDirectAPIReport",
          element: <CashoutDirectReport />,
        },
        {
          path: "businessReport",
          name: "reports-businessReport",
          element: <BusinessReport />,
        },
        {
          path: "businessAnalysisReport",
          name: "reports-businessAnalysisReport",
          element: <BusinessAnalysisReport />,
        },
        {
          path: "dailyBusinessReports",
          name: "reports-dailyBusinessReports",
          element: <DailyBusinessReports />,
        },
        {
          path: "topUpReport",
          name: "reports-topUpReport",
          element: <TopUpReport />,
        },
        {
          path: "accountStatusReports",
          name: "reports-accountStatusReports",
          element: <AccountStatusReports />,
        },
        {
          path: "users360Report",
          name: "reports-users360Report",
          element: <Users360Report />,
        },
        {
          path: "changeStatusByTxnId",
          name: "reports-changeStatusByTxnId",
          element: <ChangeStatusByTxnId />,
        },
      ]
    },
    // Admin Settings
    {
      path: "settings",
      key: 2.9,
      children: [
        // My Profile
        {
          path: "profile",
          name: "PersonalDetails",
          element: <PersonalDetails />,
        },
        // Change My Password
        {
          path: "changesPassword",
          name: "ChangesPassword",
          element: <ChangesPassword />,
        },
      ]
    },
    // Help Desk
    {
      path: "helpDesk",
      key: 2.10,
      children: [
        {
          path: "complaintList",
          name: "complaintList",
          element: <ComplaintList />,
        },
        {
          path: "newComplaint",
          name: "newComplaint",
          element: <NewComplaint />,
        },
        {
          path: "complaintDetails",
          name: "complaintDetails",
          element: <ComplaintDetails />,
        },
      ]
    }
  ],
};

export default adminRouter;
